// extracted by mini-css-extract-plugin
export default {"primeCheckbox":"Checkbox_primeCheckbox__MV+yE","partnerCheckbox":"Checkbox_partnerCheckbox__78znw"};